import * as React from 'react';

// HORO-10326: plus glyph per Figma 935:39654 — two crossed lines
// (white stroke) used as the "Start a new chat" affordance in the
// sidebar / drawer menu.
const PlusIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <path stroke="#FFFFFF" strokeWidth={1.5} strokeLinecap="round" d="M10 4v12M4 10h12" />
    </svg>
);

export default PlusIcon;
